// USP Marquee functionality
class USPMarquee {
  constructor(container) {
    this.container = container;
    this.marquee = container.querySelector('.usp-points__marquee');
    this.isDragging = false;
    this.startX = 0;
    this.startScrollLeft = 0;
    this.animationPaused = false;
    this.initialTranslate = 0;

    this.init();
  }

  init() {
    // Clone items for infinite scroll effect
    this.cloneItemsIfNeeded();

    // Add event listeners for mouse and touch interactions
    this.marquee.addEventListener('mousedown', this.startDrag.bind(this));
    this.marquee.addEventListener('touchstart', this.startDrag.bind(this), { passive: true });

    document.addEventListener('mouseup', this.stopDrag.bind(this));
    document.addEventListener('touchend', this.stopDrag.bind(this), { passive: true });

    document.addEventListener('mousemove', this.drag.bind(this));
    document.addEventListener('touchmove', this.drag.bind(this), { passive: true });

    // Prevent click events when dragging
    this.marquee.addEventListener('click', (e) => {
      if (this.moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  cloneItemsIfNeeded() {
    const items = this.marquee.querySelectorAll('.usp-points__item');
    if (items.length === 0) return;

    // Clone all items to ensure we have enough for scrolling
    items.forEach(item => {
      const clone = item.cloneNode(true);
      this.marquee.appendChild(clone);
    });
  }

  startDrag(e) {
    // Avoid blocking default scrolling; rely on CSS touch-action: pan-x
    this.isDragging = true;
    this.moved = false;

    // Pause the animation while dragging
    this.marquee.classList.add('dragging');
    this.marquee.style.animationPlayState = 'paused';
    this.marquee.style.webkitAnimationPlayState = 'paused';

    // Get the initial position
    this.startX = e.type.includes('mouse')
      ? e.pageX
      : e.touches[0].pageX;

    // Get the current computed transform
    try {
      const style = window.getComputedStyle(this.marquee);
      const transform = style.transform || style.webkitTransform;

      if (transform !== 'none') {
        // Try to use WebKitCSSMatrix if available
        if (window.WebKitCSSMatrix) {
          const matrix = new WebKitCSSMatrix(transform);
          this.initialTranslate = matrix.m41; // Get the X translation value
        } else {
          // Fallback for browsers without WebKitCSSMatrix
          const matrix = transform.match(/matrix.*\((.+)\)/);
          if (matrix && matrix[1]) {
            const values = matrix[1].split(', ');
            this.initialTranslate = parseFloat(values[4] || 0);
          }
        }
      } else {
        this.initialTranslate = 0;
      }
    } catch (err) {
      console.error('Error getting transform:', err);
      this.initialTranslate = 0;
    }
  }

  stopDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;

    // Resume the animation
    this.marquee.classList.remove('dragging');
    this.marquee.style.animationPlayState = 'running';
    this.marquee.style.webkitAnimationPlayState = 'running';

    // Set a timeout to reset the moved flag
    setTimeout(() => {
      this.moved = false;
    }, 100);
  }

  drag(e) {
    if (!this.isDragging) return;
    // Do not prevent default to keep scrolling smooth

    // Calculate the new position
    const x = e.type.includes('mouse')
      ? e.pageX
      : e.touches[0].pageX;

    const walk = x - this.startX;
    this.moved = Math.abs(walk) > 5; // Consider it a move if dragged more than 5px

    // Apply the transform directly
    this.marquee.style.transform = `translateX(${this.initialTranslate + walk}px)`;
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', function () {
  // Wait a bit to ensure all elements are properly loaded
  setTimeout(() => {
    const marqueeContainers = document.querySelectorAll('.usp-points__marquee-container');
    marqueeContainers.forEach(container => {
      new USPMarquee(container);
    });
  }, 500);
});
